import * as React from "react";
import { NativeTileShowcaseItemRegionProps, NativeTileShowcaseItemRegionFTNodeOptions } from "./typings";
import { UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { BlossomComponents } from "components/flexFramework/BlossomComponents/BlossomComponents";
import { observer } from "mobx-react";
import { withStores } from "stores";
import { normalizeOptionsData } from "src/components/flexFramework/FlexTemplateNode";

export const NativeTileShowcaseItemRegion = withStores(
  "flexModuleModelStore",
  "context"
)(
  observer((props: NativeTileShowcaseItemRegionProps) => {
    const { context, blossomComponent, flexModuleModelStore, flexTemplateNode } = props;

    /* istanbul ignore next */
    if (!blossomComponent) {
      return null;
    }

    const options = normalizeOptionsData(
      flexTemplateNode,
      flexModuleModelStore.getModel(flexTemplateNode.id)
    ) as NativeTileShowcaseItemRegionFTNodeOptions;

    return (
      <>
        <UitkLayoutFlexItem grow={options.width === "33" ? 0 : 1} maxWidth="full_width">
          <div className="NativeTileShowcaseItemRegion">
            <BlossomComponents blossomComponent={blossomComponent} context={context} />
          </div>
        </UitkLayoutFlexItem>
      </>
    );
  })
);

export default NativeTileShowcaseItemRegion;
